/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from "react";
import { Button, Row, DatePicker, Input, Select, Col, Form } from "antd";
import "../../styles/filters-form.less";
import "./ServiceTypeCreateForm.less";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  displayFormat,
  infinityDateHttpFormat,
  toHttpFormat,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";

import {
  fetchChargeNameTypeStatus,
  fetchProducts,
  fetchServiceMode,
} from "../../store/slices/rtkDictionaries";
import LocalStorageService from "../../services/LocalStorageService";
import {
  ServiceTypesDictionary,
  ServiceTypesTableProps,
  ServiceTypesTaxRate,
} from "../ServiceTypes/ServiceTypesInterfaces";
import { createServiceTypes, fetchServiceTypesAdmin } from "../../store/slices/service-types";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";
import { CharacteristicsContainer } from "../../modules/policies";
import { useCharacteristicsInitialisation } from "../../modules/policies/pages/CharacteristicsContainer/utils/useCharacteristicsInitialisation";
import { getCharFormatItem } from "../../modules/policies/services/getCharFormatItem";
import { Characteristic } from "../../lib/types/Offer";
import RequiredMark from "../common/RequiredMark/RequiredMark";
import { useAppDispatch, useAppSelector } from "../..";

const ServiceTypeCreateForm = () => {
  const dateFormat = displayFormat;
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { Option } = Select;
  const history = useHistory();
  const dateEndForCreate = moment(infinityDateHttpFormat);

  const [sumTax, setSumTax] = useState<number>(0);
  const { taxesRates, taxesRatesLoading, serviceTypes } = useAppSelector(
    (state) => state.serviceTypes
  );

  const { serviceMode, products, chargeNameTypeStatus } = useAppSelector(
    (state) => state.rtkDictionaries
  );

  useEffect(() => {
    dispatch(fetchServiceMode());
    dispatch(fetchProducts());
    dispatch(fetchChargeNameTypeStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateMessages = {
    required: "",
  };

  const onChangeTaxes = (taxRates: number[]) => {
    const taxSum = taxRates.reduce((sum: number, cur: number) => sum + cur, 0);
    setSumTax(taxSum);
  };

  const serviceTypeNameValidator = (_, name: string) => {
    const sameName = serviceTypes?.find((serviceType) => {
      const serviceTypeName = serviceType.name.toLowerCase().trim();
      const createdName = name.toLowerCase().trim();
      return serviceTypeName === createdName;
    });
    if (sameName) {
      return Promise.reject(new Error("Продукт с таким наименованием уже существует!"));
    }
    return Promise.resolve();
  };

  // ---> Характеристики <---
  const {
    fromDateCharacteristic,
    onChangeFromDateCharacteristic,
    onCheckFieldsError,
    fieldsError,
    infoCharacteristic,
    setInfoCharacteristic,
  } = useCharacteristicsInitialisation({});
  // ---> Характеристики <---

  const onFinish = (values: ServiceTypesTableProps) => {
    const params: ServiceTypesTableProps & { info?: Characteristic[] } = {
      ...values,
    };

    if (params) {
      const isValid = onCheckFieldsError(["infoCharacteristic"]);

      if (!isValid) {
        return;
      }

      const info = infoCharacteristic.map((el) => getCharFormatItem(el, 1037));

      params.tenantId = Number(LocalStorageService.getTenantId());
      params.dsc = "";
      params.toDate = toHttpFormat(values.toDate);
      params.fromDate = toHttpFormatStartOfDay(values.fromDate);
      params.taxRateMask = sumTax;
      params.baseServiceTypeId = null;
      params.info = info;
    }

    // const findIndex =
    //   serviceProfiles &&
    //   serviceProfiles.findIndex((item) => String(item.name) === String(values.name));

    // if (findIndex === -1) {
    //   await dispatch(createServiceTypes(values));
    //   history.push(`/service-profile`);
    //
    //   dispatch(fetchServiceProfiles({ queryString: queryStringServiceProfiles }));
    // } else {
    //   message.warning("Профиль с таким наименованием уже существует");
    // }

    // dispatch(fetchServiceMode());
    // dispatch(fetchProducts());
    // dispatch(fetchChargeNameTypeStatus());
    dispatch(createServiceTypes(params));
    history.push(`/service-types`);
    dispatch(fetchServiceTypesAdmin());
  };

  return (
    <div className="inner-row">
      <h1>Создание типа продукта</h1>
      <Form
        style={{ width: "100%" }}
        form={form}
        validateMessages={validateMessages}
        name="advanced_search"
        initialValues={{
          toDate: dateEndForCreate,
        }}
        className="profile-search-create-form"
        onFinish={onFinish}
      >
        <Row className="profile-search-create-form__row-label" align="middle">
          <Col span={4}>
            <RequiredMark>
              <label>Наименование</label>
            </RequiredMark>
          </Col>
          <Col span={2}>
            <RequiredMark>
              <label>Код</label>
            </RequiredMark>
          </Col>
          <Col span={2}>
            <RequiredMark>
              <label>Вид</label>
            </RequiredMark>
          </Col>
          <Col span={2}>
            <RequiredMark>
              <label>Налоги</label>
            </RequiredMark>
          </Col>
          <Col span={2}>
            <RequiredMark>
              <label>Группа продуктов</label>
            </RequiredMark>
          </Col>
          <Col span={3}>
            <RequiredMark>
              <label>Номенклатура</label>
            </RequiredMark>
          </Col>
          <Col span={2}>
            <RequiredMark>
              <label>Период действия c</label>
            </RequiredMark>
          </Col>
          <Col span={2}>
            <label>Период действия по</label>
          </Col>
        </Row>

        <Row
          className="profile-search-create-form__row-content"
          style={{ marginTop: "20px" }}
          align="top"
        >
          <Col span={4}>
            <Form.Item
              className="profile-search-create-form__col form-item-required__hidden-error__mb0"
              name="name"
              rules={[
                {
                  required: true,
                },
                {
                  validator: serviceTypeNameValidator,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item
              className="profile-search-create-form__col form-item-required__hidden-error__mb0"
              name="serviceCode"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item
              className="profile-search-create-form__col form-item-required__hidden-error__mb0"
              name="serviceModeId"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ minWidth: "100px" }}>
                {serviceMode &&
                  serviceMode.map((item: ServiceTypesDictionary) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item
              className="profile-search-create-form__col form-item-required__hidden-error__mb0"
              name="taxRateMask"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                style={{ minWidth: "100px" }}
                onChange={onChangeTaxes}
                mode="multiple"
                showArrow
              >
                {checkIsLoaded(taxesRatesLoading) &&
                  taxesRates.map((item: ServiceTypesTaxRate) => (
                    <Option key={item.id} value={item.taxRateId}>
                      {item.taxRateName ? item.taxRateName : "-"}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item
              className="profile-search-create-form__col form-item-required__hidden-error__mb0"
              name="productId"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ minWidth: "100px" }}>
                {products &&
                  products.map((item: ServiceTypesDictionary) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              className="profile-search-create-form__col form-item-required__hidden-error__mb0"
              name="chargeNameId"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ minWidth: "100px" }}>
                {chargeNameTypeStatus &&
                  chargeNameTypeStatus.map((item: ServiceTypesDictionary) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item
              className="profile-search-create-form__col form-item-required__hidden-error__mb0"
              name="fromDate"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                format={dateFormat}
                allowClear={false}
                onChange={onChangeFromDateCharacteristic}
              />
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item
              className="profile-search-create-form__col form-item-required__hidden-error__mb0"
              name="toDate"
            >
              <DatePicker disabled format={dateFormat} allowClear={false} />
            </Form.Item>
          </Col>
        </Row>

        <Row
          className="profile-search-create-form__row-content"
          style={{ marginTop: "-24px", width: "100%" }}
          align="top"
        >
          <CharacteristicsContainer
            objectTypeId={1037}
            mode="create"
            title="Характеристики Типа продукта"
            tableData={infoCharacteristic}
            setTableData={setInfoCharacteristic}
            fromDateCharacteristic={fromDateCharacteristic}
            messageWarningNotFromDate="Необходимо выбрать Дату создания Типа продукта"
            fieldsError={fieldsError}
          />
        </Row>

        <Row
          align="middle"
          style={{ borderTop: "1px solid #CCDDEE", paddingTop: "10px", marginTop: "auto" }}
          justify="center"
        >
          <Col
            span={24}
            style={{
              textAlign: "center",
            }}
          >
            <Button
              style={{
                margin: "0 8px",
              }}
              onClick={() => {
                form.resetFields();
                history.push(`/service-types`);
              }}
            >
              Отмена
            </Button>
            <Button type="primary" htmlType="submit">
              Сохранить
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ServiceTypeCreateForm;
